import { toItem } from '../mappers/item';
export function parseItemsListResponse(response, settings, thumbnailSizes) {
  const responseData = response.data;
  response.data = (responseData.data || []).map(itemData => toItem(itemData, settings, thumbnailSizes));
  response.paging = {
    cursor: responseData.nextCursor,
    size: response.data.length
  };
  return response;
}